import { render } from "./Download.vue?vue&type=template&id=5381d445&scoped=true"
import script from "./Download.vue?vue&type=script&lang=js"
export * from "./Download.vue?vue&type=script&lang=js"

import "./Download.vue?vue&type=style&index=0&id=5381d445&scoped=true&lang=css"

import exportComponent from "E:\\sanket\\rio\\rio_user\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5381d445"]])

export default __exports__